import React from 'react'
import { Box, IconButton, Link, Paper, Typography } from '@mui/material'
import { Facebook, Instagram } from '@mui/icons-material'

export const Contact = () => {
  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <Box sx={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
        <Paper
          elevation={2}
          sx={{
            mb: 3,
            display: 'flex',
            justifyContent: 'center',
            width: { xs: '100%', sm: '40%' }
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              m: 2
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant='body1' sx={{ fontWeight: 'bold', minWidth: 120 }}>
                Compagnie:
              </Typography>
              <Typography variant='body1'>Clair de Scène</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant='body1' sx={{ fontWeight: 'bold', minWidth: 120 }}>
                Responsable:
              </Typography>
              <Typography variant='body1'>Inès Du Four</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant='body1' sx={{ fontWeight: 'bold', minWidth: 120 }}>
                Téléphone:
              </Typography>
              <Link href='tel:+32495204281' color='primary'>
                +32 (0)495/20.42.81
              </Link>
            </Box>{' '}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant='body1' sx={{ fontWeight: 'bold', minWidth: 120 }}>
                Téléphone billetterie:
              </Typography>
              <Link href='tel:+32494066226' color='primary'>
                +32 (0)494/06.62.26
              </Link>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant='body1' sx={{ fontWeight: 'bold', minWidth: 120 }}>
                Email:
              </Typography>
              <Link href='mailto:clairdescene@hotmail.com' color='primary'>
                clairdescene@hotmail.com
              </Link>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
              <Typography variant='body1' sx={{ fontWeight: 'bold', minWidth: 120 }}>
                Réseaux sociaux:
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton
                  href='https://www.facebook.com/share/1B2rajxgbv/?mibextid=wwXIfr'
                  target='_blank'
                  rel='noopener noreferrer'
                  color='primary'
                  aria-label='Facebook'
                >
                  <Facebook />
                </IconButton>
                <IconButton
                  href='https://www.instagram.com/clair.de.scene'
                  target='_blank'
                  rel='noopener noreferrer'
                  color='primary'
                  aria-label='Instagram'
                >
                  <Instagram />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </div>
  )
}
